<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="ejectaddGoods(1)">新增分类</el-button>
      </el-form-item>
    </el-form>
    <!-- 分类表格 -->
    <div style="height:80%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="180"
        ></el-table-column>
        <!-- <el-table-column label="分类id" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="分类主图" width="100" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" alt style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="分类名称" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.categoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="详情图" width="100" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.details_url" alt style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteGoods(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item
          label="选择一级分类: "
          style="margin-left:20px"
          v-if="isAddCategoryOne == 2"
        >
          <el-select v-model="parentId" placeholder="请选择" clearable>
            <el-option
              v-for="item in categoryArr_one"
              :label="item.categoryName"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" :label-width="formLabelWidth">
          <el-input v-model="form.categoryName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类主图" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="true"
            :on-success="handleSuccess_cover"
            :file-list="fileList"
            list-type="picture"
            name="formData"
          >
            <el-button size="small" type="primary">点击上传(1张)</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，500px X 500px, 会自动覆盖原来的图片
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="详情左侧产品图" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="true"
            :on-success="handleSuccess_cover1"
            :file-list="fileList1"
            list-type="picture"
            name="formData"
          >
            <el-button size="small" type="primary">点击上传(1张)</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，500px X 500px, 会自动覆盖原来的图片
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="详情右侧核销系统链接"
        >
          <el-input v-model="form.link" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="详情右侧温馨提示配置(<br/>表示换行)"
        >
          <el-input
            v-model="form.details_des"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 上传文件到服务器 -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectCategory,
  updateCategory,
  deleteCategory,
  addCategory,
} from "@/services/cardCouponCategory";
export default {
  created() {
    this.select();
  },

  data() {
    return {
      goodsTitle: "",
      tableData: [],
      // 一级分类 二级分类 分类
      selectCategory: "",
      select_two_id: "",
      categoryArr: [
        { id: "0", name: "一级分类" },
        { id: "1", name: "二级分类" },
      ],
      categoryArr_one: [], //遍历一级分类
      parentId: "", //增加二级分类时选择的一级分类id
      isAddCategoryOne: 1, //增加一级分类还是二级分类
      dataList: [],
      goodsArr: [],
      dialogFormVisible: false,
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      fileList: [],
      fileList1: [],
      loading: true,
      pageCount: "",
      pageSize: 8,
      form: {
        productCategory: 1,
      },
      shuf: [],
      cover: [],
      describe: [],
    };
  },
  methods: {
    select(id) {
      // 查分类
      selectCategory(id).then((resp) => {
        console.log(resp);
        this.dataList = resp.data;
        this.loading = false;
      });
    },
    // 查询分类
    selectCategoryBtn(e) {
      console.log(e);
      this.select(e);
    },
    init() {
      this.$message({
        type: "success",
        message: "查询成功!",
      });
    },
    info() {
      this.$message({
        type: "info",
        message: "查询失败",
      });
    },
    /* 新增弹窗 */
    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增分类";
      this.fileList = [];
      this.fileList1 = [];
      this.form = {};
    },
    /* 修改弹窗 */
    ejectupdataGoods(row) {
      console.log(row);
      this.fileList = [];
      this.fileList1 = [];
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改分类";
      this.form = JSON.parse(JSON.stringify(row));
    },

    handleSuccess_cover(e) {
      console.log(e);
      this.form.img = e.data;
    },
    handleSuccess_cover1(e) {
      console.log(e);
      this.form.details_url = e.data;
    },
    /* 修改 */
    updataBtn() {
      console.log("点击了确认");
      if (
        !this.form.categoryName ||
        !this.form.img ||
        !this.form.link ||
        !this.form.details_des
      ) {
        this.$message({
          type: "info",
          message: "选项不能为空",
        });
        return;
      }
      if (this.inpitTypeName == "修改分类") {
        updateCategory(this.form).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogFormVisible = false;
            this.select();
          } else {
            this.info();
          }
        });
      } else if (this.inpitTypeName == "新增分类") {
        // 新增一级分类
        addCategory(this.form).then((res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: "新增成功!",
          });
          this.dialogFormVisible = false;
          this.select();
        });
      }
    },
    /* 删除 */
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteCategory(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(e) {
      console.log("当前页：", e);
      this.selectAll(this.goodsTitle, e);
    },
    prevClick(e) {
      console.log("上一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
    nextClick(e) {
      console.log("下一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
  },
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
</style>
